import React from 'react';

export default function SwitcherIcon({ width = 20, height = 20, fill = 'rgb(0,0,0,1)' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33398 14.1667H16.6673M16.6673 14.1667L13.334 10.8333M16.6673 14.1667L13.334 17.5M16.6673 5.83333H3.33398M3.33398 5.83333L6.66732 2.5M3.33398 5.83333L6.66732 9.16667"
        stroke={fill}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
